import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';

import { getTempleDashboard } from 'helpers/api/temples';

import {
    templeAnalyticsApiResponseSuccess,
    templeAnalyticsApiResponseError,
} from './actions';

import { TempleAnalyticsActionTypes } from './constants';

/**
 * Get Temple Dashboard
 */
function* getTempleDashboardSaga({ payload }: any): SagaIterator {
    try {
        const { templeId, ...params } = payload;

        const response = yield call(
            getTempleDashboard,
            templeId,
            params
        );

        yield put(
            templeAnalyticsApiResponseSuccess(
                TempleAnalyticsActionTypes.GET_TEMPLE_DASHBOARD,
                response.data
            )
        );
    } catch (error: any) {
        yield put(
            templeAnalyticsApiResponseError(
                TempleAnalyticsActionTypes.GET_TEMPLE_DASHBOARD,
                error
            )
        );
    }
}

/**
 * Watchers
 */
export function* watchGetTempleDashboard() {
    yield takeLatest(
        TempleAnalyticsActionTypes.GET_TEMPLE_DASHBOARD,
        getTempleDashboardSaga
    );
}

/**
 * Root Saga
 */
function* templeAnalyticsSaga() {
    yield all([
        fork(watchGetTempleDashboard),
    ]);
}

export default templeAnalyticsSaga;